import React from "react"
import { Col, Row } from "react-bootstrap"

import { ReservedFields } from "@/onboarding/features/product/models/Product"
import Field from "@/onboarding/features/product/components/shared/Field"

const Content = (): JSX.Element => (
  <div className="d-flex flex-column gap-4">
    <Row>
      <Col>
        <h3 className="h6">Tour Restrictions:</h3>
        <Row className="d-flex gap-4">
          <Col className="d-flex flex-column gap-2">
            <Field name={ReservedFields.MINIMUM_AGE} label="Minimum Age (yrs)" />
            <Field name={ReservedFields.MAXIMUM_AGE} label="Maximum Age (yrs)" />
          </Col>
          <Col className="d-flex flex-column gap-2">
            <Field name={ReservedFields.MINIMUM_HEIGHT} label="Minimum Height (meters)" />
            <Field name={ReservedFields.MAXIMUM_HEIGHT} label="Maxmum Height(meters)" />
          </Col>
          <Col className="d-flex flex-column gap-2">
            <Field name={ReservedFields.MINIMUM_WEIGHT} label="Minimum Weight (kgs)" />
            <Field name={ReservedFields.MAXIMUM_WEIGHT} label="Maximum Weight (kgs)" />
          </Col>
          <Col className="d-flex flex-column gap-2">
            <Field
              name={ReservedFields.MEDICAL_CONDITION_RESTRICTIONS}
              label="Medical Conditions"
            />
          </Col>
        </Row>
      </Col>
    </Row>
    <Row className="d-flex gap-4">
      <Col>
        <h3 className="h6">This tour provides:</h3>
        <Row className="mb-3">
          <Col className="d-flex flex-column gap-2">
            <Field name={ReservedFields.INSTRUCTORS_PROVIDED} label="Instructors" />
            <Field name={ReservedFields.CHANGING_FACILITIES_PROVIDED} label="Changing Facilities" />
            <Field name={ReservedFields.STORAGE_LOCKERS_PROVIDED} label="Storage Lockers" />
            <Field name={ReservedFields.TOWELS_PROVIDED} label="Towels For Water Activities" />
            <Field name={ReservedFields.WAIVER_FORMS_REQUIRED} label="Waiver forms to be signed" />
          </Col>
        </Row>
      </Col>
      <Col>
        <h3 className="h6">This tour is suitable for people with:</h3>
        <Row className="mb-3">
          <Col className="d-flex flex-column gap-2">
            <Field name={ReservedFields.WHEELCHAIR_SUITABLE} label="Wheelchairs" />
            <Field name={ReservedFields.BLIND_SUITABLE} label="Blindness" />
            <Field name={ReservedFields.DEAF_SUITABLE} label="Deafness" />
            <Field name={ReservedFields.WALKING_DIFFICULTY_SUITABLE} label="Walking Difficulties" />
          </Col>
        </Row>
      </Col>
      <Col>
        <Field
          name={ReservedFields.INCLUDED_EQUIPMENT}
          label="What equipment is included on tour?"
        />
      </Col>
      <Col>
        <Field
          name={ReservedFields.GUEST_GUIDANCE}
          label="What should guests be advised to bring on tour?"
        />
      </Col>
    </Row>
  </div>
)

export default Content
